import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  appLoading: true,
  appBarLoading: false,
  drawerOpen: true,
  drawerMini: false,
  sessionExpired: false,
  accessRestricted: false,
  darkMode: false,
  background: null,
  openDrawerEnabled: true,
  navbarExtraBreadcrumb: null,
  manualDrawerMini: false,
  menuMode: null,
  selectedCountryId: null,
  showRoles: false,
  showUsers: false,
  showActions: false,
  showModules: false,
  showResponsivas: false,
  showOwnResponsivas: false,
  showGroups: false,
  changePassword: false,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    // Give case reducers meaningful past-tense "event"-style names
    setAppLoading(state, action) {
      state.appLoading = action.payload;
    },
    setAppBarLoading(state, action) {
      state.appBarLoading = action.payload;
    },
    setDrawerOpen(state, action) {
      state.drawerOpen = action.payload;
    },
    setDrawerMini(state, action) {
      state.drawerMini = action.payload;
    },
    setManualDrawerMini(state, action) {
      state.manualDrawerMini = action.payload;
    },
    setDrawerEnabled(state, action) {
      state.openDrawerEnabled = action.payload;
    },
    setSessionExpired(state, action) {
      state.sessionExpired = action.payload;
    },
    setAccessRestricted(state, action) {
      state.accessRestricted = action.payload;
    },
    setDarkMode(state, action) {
      state.darkMode = action.payload;
    },
    setNavbarExtraBreadcrumb(state, action) {
      state.navbarExtraBreadcrumb = action.payload;
    },
    setMenuMode(state, action) {
      state.menuMode = action.payload;
    },
    setSelectedCountryId(state, action) {
      state.selectedCountryId = action.payload;
    },
    showRolesReducer(state, action) {
      state.showRoles = action.payload;
    },
    showUsersReducer(state, action) {
      state.showUsers = action.payload;
    },
    showGroupsReducer(state, action) {
      state.showGroups = action.payload;
    },
    showActionsReducer(state, action) {
      state.showActions = action.payload;
    },
    showModulesReducer(state, action) {
      state.showModules = action.payload;
    },
    showResponsivasReducer(state, action) {
      state.showResponsivas = action.payload;
    },
    showOwnResponsivasReducer(state, action) {
      state.showOwnResponsivas = action.payload;
    },
    setChangePassword(state, action) {
      state.changePassword = action.payload;
    },
  },
});

// `createSlice` automatically generated action creators with these names.
// export them as named exports from this "slice" file
export const {
  setAppLoading,
  setAppBarLoading,
  setDrawerOpen,
  setDrawerMini,
  setManualDrawerMini,
  setDrawerEnabled,
  setSessionExpired,
  setAccessRestricted,
  setDarkMode,
  setNavbarExtraBreadcrumb,
  setMenuMode,
  setSelectedCountryId,
  showRolesReducer,
  showUsersReducer,
  showGroupsReducer,
  showActionsReducer,
  showModulesReducer,
  showResponsivasReducer,
  showOwnResponsivasReducer,
  setChangePassword,
} = appSlice.actions;

// Export the slice reducer as the default export
export default appSlice.reducer;
